/* eslint-disable no-console */
(function initShopifyTrackingAutolookup() {
  const PROXY_CANDIDATES = ['/apps/jeanity-track', '/apps/track-order'];
  const INPUT_SELECTORS = [
    'input[name="tracking_number"]',
    '#tracking_number',
    'input[data-tracking-number]',
  ];
  const ORDER_INPUT_SELECTORS = [
    'input[name="order_number"]',
    '#order_number',
    'input[data-order-number]',
  ];
  const BUTTON_SELECTORS = [
    'button[type="submit"]',
    '[data-track-submit]',
    '#track-submit',
  ];

  function findTrackingInput() {
    for (const selector of INPUT_SELECTORS) {
      const el = document.querySelector(selector);
      if (el) return el;
    }
    return null;
  }

  function findOrderInput() {
    for (const selector of ORDER_INPUT_SELECTORS) {
      const el = document.querySelector(selector);
      if (el) return el;
    }
    return null;
  }

  function findSubmitButton() {
    for (const selector of BUTTON_SELECTORS) {
      const el = document.querySelector(selector);
      if (el) return el;
    }
    return null;
  }

  function chooseProxyEndpoint() {
    const hinted = document.body?.dataset?.trackingProxyPath;
    if (hinted && PROXY_CANDIDATES.includes(hinted)) return hinted;
    return PROXY_CANDIDATES[0];
  }

  function maskTracking(value) {
    const raw = String(value || '').trim();
    if (!raw) return '';
    if (raw.length <= 6) return raw.slice(0, 2) + '***';
    return raw.slice(0, 3) + '***' + raw.slice(-3);
  }

  function setStatusText(message) {
    const target = document.querySelector('[data-track-status]');
    if (target) target.textContent = message;
  }

  function applyDefaultInputText() {
    const orderInput = findOrderInput();
    if (orderInput && !String(orderInput.value || '').trim()) {
      orderInput.placeholder = 'Enter Order Number';
    }

    const trackingInput = findTrackingInput();
    if (trackingInput) {
      trackingInput.placeholder = 'Enter tracking number here';
    }
  }

  async function runTrackingLookup(trackingNumber) {
    const endpoint = chooseProxyEndpoint();
    const payload = {
      mode: 'tracking_lookup',
      tracking_number: trackingNumber,
    };

    console.log('[tracking-page] POST tracking lookup', {
      endpoint,
      tracking_number: maskTracking(trackingNumber),
    });

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const json = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(json?.message || 'Tracking lookup failed.');
    }
    return json;
  }

  async function autoloadFromQueryParam() {
    const params = new URLSearchParams(window.location.search || '');
    const trackingNumber = String(params.get('tracking_number') || '').trim();
    if (!trackingNumber) return;

    console.log('[tracking-page] URL tracking_number detected', {
      tracking_number: maskTracking(trackingNumber),
    });

    const input = findTrackingInput();
    if (input) input.value = trackingNumber;

    // Prefer triggering the existing theme submit handler so UI rendering stays consistent.
    const trackingForm = input ? input.closest('form') : document.querySelector('form[data-form="tracking"]');
    if (trackingForm) {
      console.log('[tracking-page] triggering tracking form submit', {
        tracking_number: maskTracking(trackingNumber),
      });
      if (typeof trackingForm.requestSubmit === 'function') {
        trackingForm.requestSubmit();
      } else {
        trackingForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
      return;
    }

    const submitButton = findSubmitButton();
    if (submitButton) submitButton.disabled = true;
    setStatusText('One Moment, Checking tracking updates...');

    try {
      const result = await runTrackingLookup(trackingNumber);
      console.log('[tracking-page] tracking lookup success', {
        status_code: result?.status_code || '',
        steps: Array.isArray(result?.steps) ? result.steps.length : 0,
      });
      window.dispatchEvent(new CustomEvent('tracking:lookup:success', { detail: result }));
      setStatusText('');
    } catch (error) {
      console.log('[tracking-page] tracking lookup failed', { message: error?.message || String(error) });
      window.dispatchEvent(new CustomEvent('tracking:lookup:error', { detail: error }));
      setStatusText(error?.message || 'Unable to load tracking right now.');
    } finally {
      if (submitButton) submitButton.disabled = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function onReady() {
      applyDefaultInputText();
      autoloadFromQueryParam();
    }, { once: true });
  } else {
    applyDefaultInputText();
    autoloadFromQueryParam();
  }
})();
